module.exports = __webpack_public_path__ + "static/media/Joseph Lambourne.2cda08e9.png";